import * as React from "react";
import { Col, Form, Row } from "react-bootstrap";
import Typography from '@mui/material/Typography';
import Phone from "../form/Phone";
import Email from "../form/Email";
import FirstName from "../form/FirstName";
import LastName from "../form/LastName";
import { config } from '_config';

export default function MonitoringStep2({ state, onChange, onBlur, validated }) {
  if (config.skin === 'v2-basic') {
    return (
      <div className="question">
        <h2>Contact Information</h2>
        <Typography className="regular">
          Please provide your contact information below. We will use this information to create your account and to alert
          you of the results of your Comprehensive Search Report order. This information may be updated at anytime through
          your online Trademark Genius account.
        </Typography>
        <div className="polaroid">
        <Form id="TrademarkForm" noValidate validated={validated}>
          <div className="one-column-form">
            <FirstName id="firstName" label="First Name"
                      value={state.firstName} onChange={onChange} />
            <LastName id="lastName" label="Last Name" value={state.lastName}
                      onChange={onChange} />
            <Phone id="phone" label="Phone" state={state} onChange={onChange} />
            <Email id="email" label="Email" state={state} onChange={onChange} onBlur={onBlur} />
          </div>
        </Form>
        </div>
      </div>
    );
  }

  return (
    <div className="question">
      <div className="polaroid">
      <h2>Contact Information</h2>
      <p>Please provide your contact information below. We will use this information to create your account and to alert
        you of the results of your Comprehensive Search Report order. This information may be updated at anytime through
        your online Trademark Genius account.</p>
      <Form id="TrademarkForm" noValidate validated={validated}>
        <div className="one-column-form">
          <FirstName id="firstName" label="First Name"
                    value={state.firstName} onChange={onChange} />
          <LastName id="lastName" label="Last Name" value={state.lastName}
                    onChange={onChange} />
          <Phone id="phone" label="Phone" state={state} onChange={onChange} />
          <Email id="email" label="Email" state={state} onChange={onChange} onBlur={onBlur} />
        </div>
      </Form>
      </div>
    </div>
  );
}
